// extracted by mini-css-extract-plugin
module.exports = {"headingTunisia":"tunisianow_headingTunisia____KiX"};